import { PersonDataBasicDto } from './../../interfaces/IPersonDataBasicDto';
import { TipoIdentificacion } from './../../../nodo/modules/seleccion/requisiciones/interfaces/IKanbanResponse';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { StackDirectives } from 'src/app/shared/directives/stack-directives';
import { DatosBasicos } from '../../components/datos-basicos/datos-basicos';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { A } from '@angular/cdk/keycodes';
import { ActivatedRoute } from '@angular/router';
import { RequisicionesCandidatoService } from 'src/app/apps/nodo/modules/seleccion/requisiciones/services/requisiciones-candidato.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { PersonService } from '../../services/person.service';
import { InfoAcademica } from '../../components/info-academica/info-academica';
import { ToastrService } from 'ngx-toastr';
import { InfoLaboral } from '../../components/info-laboral/info-laboral';
import { InfoDocumentos } from '../../components/info-documentos/info-documentos';
import { ICandidateInfo } from '../../interfaces/ICandidatoInfo';
import { InfoFinalizar } from '../../components/info-finalizar/info-finalizar';
import { PreRegistro } from '../../components/pre-registro/pre-registro';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { tr } from 'date-fns/locale';
import { DatosBasicosAdicionales } from '../../components/datos-basicos-adicionales/datos-basicos-adicionales';
import { ITiempoEtapa } from '../../interfaces/ITiempoEtapa';
import { InfoCandidateStagesService } from '../../services/info-candidate.stages.service';
import { InfoVehicular } from '../../components/info-vehicular/info-vehicular';

interface StepIndexMap {
    DATOS_BASICOS: number;
    DATOS_BASICOS_ADICIONALES: number;
    INFO_VEHICULAR: number;
    INFO_ACADEMICA: number;
    INFO_LABORAL: number;
    DOCUMENTACION: number;
    FINALIZAR: number;
}

@Component({
    selector: 'app-informacion-candidato-page',
    imports: [
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        DatosBasicos,
        StackDirectives,
        MatStepperModule,
        InfoAcademica,
        InfoLaboral,
        InfoDocumentos,
        InfoFinalizar,
        PreRegistro,
        CommonModule,
        DatosBasicosAdicionales,
        InfoVehicular
    ],
    templateUrl: './informacion-candidato-page.html',
    styleUrl: './informacion-candidato-page.css',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformacionCandidatoPage {
    @ViewChild('stepper') stepper!: MatStepper;
    @ViewChild(DatosBasicos) datosBasicosComp!: DatosBasicos;
    @ViewChild(DatosBasicosAdicionales) datosBasicosAdicionalesComp!: DatosBasicosAdicionales;
    @ViewChild(InfoDocumentos) infoDocumentosComp!: InfoDocumentos;
    @ViewChild(InfoFinalizar) infoFinalizarComp!: InfoFinalizar;
    @ViewChild(InfoVehicular) infoVehicularComp!: InfoVehicular;

    private fb = inject(FormBuilder);
    private ac = inject(ActivatedRoute);
    private loader = inject(LoaderService);
    private cdr = inject(ChangeDetectorRef);
    private toastr = inject(ToastrService);
    private infoCandidateStageService = inject(InfoCandidateStagesService);

    idEncrypt: any;
    stepDatosBasicosValid: boolean = false;
    stepDatosBasicosAdicionalesValid: boolean = false;
    stepAcademicValid: boolean = false;
    stepWorkingValid: boolean = false;
    stepDocumentosValid: boolean = false;
    stepFinalizarValid: boolean = false;
    codEmp: string;
    tipIde: string;
    confirmoPreRegistro: boolean = false;
    requiereVehiculo: boolean = false;
    stepVehicularValid: boolean = false;
    allowedIndex = 0;

    stepIndex: StepIndexMap = {
        DATOS_BASICOS: 0,
        DATOS_BASICOS_ADICIONALES: 1,
        INFO_VEHICULAR: -1,
        INFO_ACADEMICA: 2,
        INFO_LABORAL: 3,
        DOCUMENTACION: 4,
        FINALIZAR: 5
    };

    tiemposEtapas: Record<number, ITiempoEtapa> = {};
    etapasEnviadas: Record<number, boolean> = {};

    etapasNombre = [
        'Datos básicos',
        'Datos básicos adicionales',
        'Información académica',
        'Información laboral',
        'Documentación',
        'Finalizar'
    ];

    ngOnInit(): void {
        this.buildStepConfig();
        this.ac.queryParams.subscribe((params) => {
            this.idEncrypt = params['q'] as any;
        });
    }

    ngAfterViewInit(): void {
        const now = Date.now();

        this.tiemposEtapas[this.allowedIndex] = {
            nombre: this.etapasNombre[this.allowedIndex],
            inicio: now
        };
    }

    saveDatosBasicos() {
        this.datosBasicosComp.saveBasicData();
        this.stepper.next();
    }

    saveDatosBasicosAdicionales() {
        this.datosBasicosAdicionalesComp.saveBasicDataAditional();
        this.stepper.next();
    }

    onDatosBasicosValidChange(isValid: boolean) {
        this.stepDatosBasicosValid = isValid;
        if (isValid) {
            this.codEmp = this.datosBasicosComp.form.get('codEmp')?.value || '';
            this.tipIde = this.datosBasicosComp.form.get('tipIde')?.value || '';
        }
    }
    onDatosBasicosAdicionalesValidChange(isValid: boolean) {
        this.stepDatosBasicosAdicionalesValid = isValid;
        if (isValid) {
            // this.codEmp = this.datosBasicosComp.form.get('codEmp')?.value || '';
            // this.tipIde = this.datosBasicosComp.form.get('tipIde')?.value || '';
        }
    }
    onAcademicValidChange(isValid: boolean) {
        this.stepAcademicValid = isValid;
    }
    onWorkingValidChange(isValid: boolean) {
        this.stepWorkingValid = isValid;
        if (isValid) this.stepDatosBasicosValid = true;
    }

    saveDocuments() {
        this.infoDocumentosComp.uploadFile$().subscribe((response) => {
            if (response) {
                this.stepper.next();
            }
        });
    }

    infoLaboral() {
        this.stepDocumentosValid = true;
        this.stepper.next();
    }

    onDocumentosValidChange(isValid: boolean) {
        // this.stepDocumentosValid = true;
    }

    finaliceProcess() {
        const now = Date.now();
        if (this.allowedIndex !== null) {
            const etapa = this.tiemposEtapas[this.allowedIndex];
            if (etapa && !etapa.fin) {
                etapa.fin = now;
                etapa.duracionMs = now - etapa.inicio;

                if (!this.etapasEnviadas[this.allowedIndex]) {
                    this.sendStage(etapa, this.allowedIndex);
                    this.etapasEnviadas[this.allowedIndex] = true;
                }
            }
        }
        this.infoFinalizarComp.finaliceProcess();
    }

    onPreRegistroValidChange(confirmed: boolean) {
        this.confirmoPreRegistro = confirmed;
    }

    onRequiereVehiculoChange(requiere: boolean) {
        this.requiereVehiculo = requiere;
        this.buildStepConfig();
        this.cdr.markForCheck();
    }

    onVehicularValidChange(isValid: boolean) {
        this.stepVehicularValid = isValid;
    }

    private buildStepConfig(): void {
        const nombres: string[] = [];
        let idx = 0;

        this.stepIndex.DATOS_BASICOS = idx;
        nombres.push('Datos básicos');
        idx++;

        this.stepIndex.DATOS_BASICOS_ADICIONALES = idx;
        nombres.push('Datos básicos adicionales');
        idx++;

        if (this.requiereVehiculo) {
            this.stepIndex.INFO_VEHICULAR = idx;
            nombres.push('Información vehicular');
            idx++;
        } else {
            this.stepIndex.INFO_VEHICULAR = -1;
        }

        this.stepIndex.INFO_ACADEMICA = idx;
        nombres.push('Información académica');
        idx++;

        this.stepIndex.INFO_LABORAL = idx;
        nombres.push('Información laboral');
        idx++;

        this.stepIndex.DOCUMENTACION = idx;
        nombres.push('Documentación');
        idx++;

        this.stepIndex.FINALIZAR = idx;
        nombres.push('Finalizar');

        this.etapasNombre = nombres;
    }

    onFinalizarValidChange(isValid: boolean) {
        this.stepFinalizarValid = isValid;
        // var dataPerson = this.infoFinalizarComp?.person;
        // if (!dataPerson?.candidateInfo.firmaDigital) {
        //   this.stepFinalizarValid = isValid;
        // }
    }

    onStepChange(event: StepperSelectionEvent): void {
        const now = Date.now();
        const next = event.selectedIndex;
        const prev = event.previouslySelectedIndex;

        const esAvance = next > prev;

        if (esAvance && this.allowedIndex !== null) {
            const etapa = this.tiemposEtapas[this.allowedIndex];

            if (etapa && !etapa.fin) {
                etapa.fin = now;
                etapa.duracionMs = now - etapa.inicio;

                if (!this.etapasEnviadas[this.allowedIndex]) {
                    this.sendStage(etapa, this.allowedIndex);
                    this.etapasEnviadas[this.allowedIndex] = true;
                }
            }
        }

        if (!this.tiemposEtapas[next]) {
            this.tiemposEtapas[next] = {
                nombre: this.etapasNombre[next],
                inicio: now
            };
        }

        this.allowedIndex = next;

        if (next === this.stepIndex.DOCUMENTACION) {
            this.stepDocumentosValid = true;
        }

        // Recargar vehículos al entrar al step vehicular
        if (next === this.stepIndex.INFO_VEHICULAR && this.infoVehicularComp && this.idEncrypt) {
            this.loader.show('Cargando vehículos...');
            this.infoVehicularComp.cargarVehiculos(this.idEncrypt);
        }
    }

    sendStage(etapa: ITiempoEtapa, etapaCodigo: number): void {
        const payload = {
            idEncrypt: this.idEncrypt,
            etapaCodigo: etapaCodigo,
            etapaNombre: etapa.nombre,
            inicioMs: etapa.inicio,
            finMs: etapa.fin,
            duracionMs: etapa.duracionMs
        };

        this.infoCandidateStageService.saveStage(payload).subscribe({
            next: (response) => {},
            error: (error) => {}
        });
    }
}
